export function productsForBranch(products, branchId) {
  return products.map(product => {
    const price = branchId == null ? null : (product.product_branch_prices || [])
      .find(price => String(price.branch_id) === String(branchId));
    return {
      ...product,
      mandate_pricing_min: price && price.mandate_pricing_min != null
        ? price.mandate_pricing_min : product.mandate_pricing_min,
      mandate_pricing_max: price && price.mandate_pricing_max != null
        ? price.mandate_pricing_max : product.mandate_pricing_max,
    };
  });
}

export default {
  data: () => ({ baseProducts: [] }),
  computed: {
    pricingBranchId() {
      return this.selectedCustomer ? this.selectedCustomer.branch_id : null;
    },
    products() {
      // Keep defaults intact so switching customers always starts from fresh prices.
      return productsForBranch(this.baseProducts, this.pricingBranchId)
        .sort((a, b) => Number(a.mandate_pricing_min) - Number(b.mandate_pricing_min));
    },
  },
  watch: {
    pricingBranchId() {
      this.selectedProduct = null;
      this.selectedPrice = null;
      this.selectedQuantity = null;
      this.productSelectedModalShow = false;
    },
  },
};
